export default {
  applyDocument: {},
  applyDocuments: [],
  applyDocumentHistory: [],
  organizations: [],
  directions: [],
}
